<template>
  <div>
    <navbar/>
    <error-panel showInPopup="false" />
    <Spinner :loaded="loaded" />
    <main role="main" v-if="loaded">
        <div class="jumbotron" id="tl-jumbotron">
          <div class="container">
            <div class="row tl-link-block tl-link-block-header pb-1 mb-3">

              <h4 class="col-12">
                <span class="bi bi-people-fill tl-user-profile-icon mr-2 mb-3 text-danger"></span>
                Discover
                <div>
                  <span class="tl-subtext-header">A random selection of the latest public bookmarks saved by the community</span>
                </div>
              </h4>
            </div>

          <div data-title="emptyState" v-if="loaded && !hasLinks" class="row tl-link-block p-4">
            <div class="col-sm-1 d-none d-sm-block">
                <i class="bi bi-emoji-astonished tl-emptystate-icon"></i>
            </div>
            <div class="col-sm-9 col-12">
              <div class="tl-link-title">
                  Couldn't find anything...
              </div>
              <div class="tl-link-small mt-3">
                  Maybe everyone is sleeping?
              </div>
            </div>
          </div>

          <LinkList v-if="hasLinks" :links="links"/>
          </div>
        </div>
      </main>

    <tlfooter v-if="loaded"/>
  </div>
</template>

<script>
import BackendClient from "@/rest/backend-client";
import navbar from "@/components/NavBar";
import tlfooter from "@/components/Footer";
import ErrorPanel from "@/components/ErrorPanel";
import Spinner from "@/components/Spinner";
import LinkList from "@/components/LinkList";

export default {
  name: "Links",
  head: {
    title: 'just bookmark it! - discover public bookmarks'
  },
  components: {
    ErrorPanel, navbar, tlfooter, Spinner, LinkList
  },
  props: ['owner'],
  data() {
    return {
      loaded: false,
      links: null,
      backendClient: new BackendClient()
    }
  },
  mounted () {
    this.backendClient.discover().then(responseData => {
      this.links = responseData.links;
      this.loaded = true;
    });
  },
  computed: {
    hasLinks() {
      return this.links && this.links.length > 0;
    }
  }
}
</script>

<style scoped>

</style>
